import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  LucideAngularModule,
  X,
  FileText,
  Loader2,
  AlertCircle,
} from 'lucide-angular';
import { PendingAttachment } from '../../grading.types';
import { ImagePreviewModalComponent, PreviewItem } from '../image-preview-modal/image-preview-modal.component';

@Component({
  selector: 'app-input-attachments-preview',
  standalone: true,
  imports: [CommonModule, LucideAngularModule, ImagePreviewModalComponent],
  templateUrl: './input-attachments-preview.component.html',
  styleUrl: './input-attachments-preview.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputAttachmentsPreviewComponent {
  readonly pendingAttachments = input<PendingAttachment[]>([]);

  readonly attachmentRemoveRequested = output<PendingAttachment>();

  protected readonly icons = {
    X,
    FileText,
    Loader2,
    AlertCircle,
  };

  protected previewItem: PreviewItem | null = null;

  protected isPdf(mimeType: string): boolean {
    return mimeType === 'application/pdf';
  }

  protected openPreview(attachment: PendingAttachment): void {
    const url = attachment.signedUrl || attachment.previewUrl;
    if (url) {
      this.previewItem = {
        url,
        fileName: attachment.fileName,
        mimeType: attachment.mimeType,
      };
    }
  }

  protected closePreview(): void {
    this.previewItem = null;
  }

  protected requestRemoveAttachment(attachment: PendingAttachment, event: Event): void {
    event.stopPropagation();
    this.attachmentRemoveRequested.emit(attachment);
  }
}
